<template>
  <BaseCustomizeMetal componentCode="G" />
</template>
<script>
import BaseCustomizeMetal from "@/components/customizeMetal/traditionalMetal/BaseCustomizeMetal/index.vue";
export default {
  name: "CustomizeMetalG",
  components: {
    BaseCustomizeMetal,
  },
};
</script>
<style scoped lang="scss">
::v-deep {
  .metal-text {
    top: 77px;
    left: 93px;
    @include betweenTableTablePro {
      top: 50px;
      left: 44px;
    }
    @include table {
      top: 35px;
      left: 19px;
    }
    @include phone {
      top: 27px;
      left: 4px;
    }
  }
  .templeName {
    height: 24px;
    width: 163px;
    .textContainer {
      width: 163px;
    }
  }
  .godName {
    width: 309px;
    height: 62px;
    .textContainer {
      width: 309px;
    }
  }
  .gift {
    margin: 0 0 auto auto;
    width: 223px;
    height: 40px;
    .textContainer {
      width: 223px;
    }
  }
  .respect {
    position: absolute;
    bottom: 5px;
    left: 15px;
  }
}
</style>
